import { CommentGrid } from '../components/CommentGrid'

/**
 * ホームページ
 */
export function HomePage() {
  return <CommentGrid />
}
